import Draft from "components/Drafts/List/Item"

import { ComponentProps } from "."
import { Li, Ul } from "./styled"

const Drafts = ({
  drafts,
  hasAdditionalInstructions = true,
  isAdmin,
  isEditor
}: ComponentProps) => (
  <Ul aria-label="Drafts">
    {drafts.map((draft) => (
      <Li aria-label={draft.title} key={draft.id}>
        <Draft
          {...draft}
          hasAdditionalInstructions={hasAdditionalInstructions}
          isAdmin={isAdmin}
          isEditor={isEditor}
        />
      </Li>
    ))}
  </Ul>
)

export default Drafts
